import get from 'lodash/get';
import { GEOGRAPHICAL_MAP, LOCATION_MODE } from 'utils/constants/Map';
import { optionalFormField } from 'utils/methods/helpers';
import { patrolFormFields, virtualPatrolFormFields } from 'utils/patrol';

export const patrolTaskGeneralSection = patrolDefDetails => {
  return [
    virtualPatrolFormFields.mobilePatrolIcon(
      patrolDefDetails?.others?.mobilePatrol?.value,
    ),
    virtualPatrolFormFields.patrolName,
    !patrolDefDetails?.others?.mobilePatrol?.value &&
      virtualPatrolFormFields.businessClient,
    !patrolDefDetails?.others?.mobilePatrol?.value &&
      virtualPatrolFormFields.site,
    virtualPatrolFormFields.scheduledStartTime,
    virtualPatrolFormFields.expectedDuration,
  ];
};

export const patrolDetailSection = ({
  siteLocation,
  patrolDefDetails,
  uploadPatrolTask,
  surfaceImage,
}) => {
  const { checkpoints, returntostart } = virtualPatrolFormFields;
  const { checkpointsImage } = patrolFormFields;

  return [
    returntostart(patrolDefDetails?.detailedInfo?.returnToStart?.value),

    ...optionalFormField({
      showWhen: surfaceImage && surfaceImage.id !== GEOGRAPHICAL_MAP.id,
      field: checkpointsImage({
        selectedSiteDetailImages: surfaceImage,
        displayEvidence: true,
        uploadPatrolTask,
      }),
    }),
    ...optionalFormField({
      showWhen: surfaceImage && surfaceImage.id === GEOGRAPHICAL_MAP.id,
      field: checkpoints({
        additionalPolygon: siteLocation,
        additionalPolygonMode: LOCATION_MODE.HIGH_DETAIL,
        uploadPatrolTask,
        evidenceCollection: true,
      }),
    }),
  ];
};

export const setUserLocation = ({ patrollerInfo, firstLocation }) => {
  return patrollerInfo.operational?.location
    ? patrollerInfo.operational.location
    : {
        point: {
          latitude: get(firstLocation.point, 'latitude'),
          longitude: get(firstLocation.point, 'longitude'),
        },
      };
};
